const state = {
    USER_LOGIN_OK: "13103",
    USER_LOGIN_FAILED: "13104",
    USER_LOGIN_NOT_ACTIVATED: "13107",
    ACCOUNT_TYPES: {
        CCS_USER_TYPE_SUPPORT: "159001",
        CCS_USER_TYPE_ACCOUNT_OWNER: "159002",
        CCS_USER_TYPE_CCS_ACCOUNT: "159003",
        CCS_USER_TYPE_DOMAINS_ACCOUNT: "159004"
    },
    user_data: {},
    account_data: {
        is_account_owner: false
    },
    account_limits: {},
    user_logged_in: false,
    session_verified: false,
    check_session_executed: false,
};

const getters = {
    isAccountOwner: (state) => {
        if (Object.entries(state.account_data).length === 0) {
            return false;
        }

        if (state.account_data.hasOwnProperty("is_account_owner") === false) {
            return false;
        }

        return state.account_data.is_account_owner;
    },
    isReseller: (state) => {
        if (Object.entries(state.account_data).length === 0) {
            return false;
        }

        if (state.account_data.hasOwnProperty("is_reseller") === false) {
            return false;
        }

        return state.account_data.is_reseller;
    },
};

const actions = {
    LoginAsSupport({ commit }, user_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.support_sso_login");
            this._vm.$axios
                .post(r, {
                    user_data: user_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        if (response.data.data.user_login_status === state.USER_LOGIN_OK) {
                            commit("storeUserData", response.data.data.user_data);
                            commit("setSessionAccountData", response.data.data.account_data);
                            commit("setSessionAccountLimits", response.data.data.account_limits);
                            resolve();
                        } else {
                            reject("Login failed");
                        }
                    } else {
                        console.log(response.data);
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    console.log('d', error);
                    reject(error);
                })
                .finally(() => {});
        });
    },

    LoginUser({ commit }, user_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.login");
            this._vm.$axios
                .post(r, {
                    user_data: user_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        if (response.data.data.user_login_status === state.USER_LOGIN_OK) {
                            commit("storeUserData", response.data.data.user_data);
                            commit("setSessionAccountData", response.data.data.account_data);
                            commit("setSessionAccountLimits", response.data.data.account_limits);
                            resolve();
                        } else {
                            reject(response.data.data);
                        }
                        // } else if (response.data.data.user_login_status === state.USER_LOGIN_NOT_ACTIVATED) {
                        //     reject(
                        //         "To activate your panel account please check your email." +
                        //         "<br><br>" +
                        //         "If you did not receive the activation e-mail, click the button below to resend it."
                        //     );
                        // } else {
                        //     reject("Login failed");
                        // }
                    } else {
                        console.log(response.data);
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    console.log('d', error);
                    reject(error);
                })
                .finally(() => {});
        });
    },

    LoginAs({ commit }, user_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.login_as");
            this._vm.$axios
                .post(r, {
                    user_data: user_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        if (response.data.data.user_login_status === state.USER_LOGIN_OK) {
                            commit("storeUserData", response.data.data.user_data);
                            commit("setSessionAccountData", response.data.data.account_data);
                            commit("setSessionAccountLimits", response.data.data.account_limits);
                            resolve();
                        } else {
                            reject("Login as failed");
                        }
                    } else {
                        console.log(response.data);
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    console.log('d', error);
                    reject(error);
                })
                .finally(() => {});
        });
    },

    LogoutUser({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.logout");
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        let user_data = {};
                        if ("company_id" in state.user_data) {
                            user_data = {
                                username: state.user_data.username,
                                email: state.user_data.email,
                                company_id: state.user_data.company_id,
                                user_type: state.user_data.user_type
                            };
                        }
                        let logout_data = {
                            user_logged_in: state.user_logged_in,
                            user_data: user_data
                        };
                        commit("logoutUser");
                        resolve(logout_data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    LogoutAsUser({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.logout_as_user");
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        let user_data = {};
                        resolve();
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    CheckSession({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.check_session");
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        if (response.data.data.user_login_status === state.USER_LOGIN_OK) {
                            commit("setSessionUserData", response.data.data.user_data);
                            commit("setSessionAccountData", response.data.data.account_data);
                            commit("setSessionAccountLimits", response.data.data.account_limits);
                            resolve();
                        } else {
                            reject("Session failed");
                        }
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    Pre2FACheckSession({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.pre2fa_check_session");
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        if (response.data.data.user_login_status === state.USER_LOGIN_OK) {
                            commit("setSessionUserData", response.data.data.user_data);
                            commit("setSessionAccountData", response.data.data.account_data);
                            commit("setSessionAccountLimits", response.data.data.account_limits);
                            resolve();
                        } else {
                            reject("Session failed");
                        }
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    ForgotPassword({ commit }, user_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.forgot_password");
            this._vm.$axios
                .post(r, {
                    user_data: user_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve();
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    ResetPassword({ commit }, user_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.reset_password");
            this._vm.$axios
                .post(r, {
                    user_data: user_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve();
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    ChangePassword({ commit }, user_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.change_password");
            this._vm.$axios
                .post(r, {
                    user_data: user_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve();
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    GetSubAccounts({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.sub_accounts");
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    GetSubAccount({ commit }, sub_account_id) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.get_sub_account", { sub_account_id: sub_account_id });
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    GetDomainsDataForSubAccounts({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.get_domains_data_for_sub_accounts");
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    SaveSubAccount({ commit }, sub_account_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.save_sub_account");
            this._vm.$axios
                .post(r, {
                    sub_account_data: sub_account_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    DeleteSubAccounts({ commit }, sub_accounts) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.delete_sub_accounts");
            this._vm.$axios
                .post(r, {
                    sub_accounts: sub_accounts
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve();
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    CreateAccountFromInvite({ commit }, user_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.invite_reply");
            this._vm.$axios
                .post(r, {
                    user_data: user_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve();
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    Get2FAData({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.get_2fa_data");
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    Get2FASecret({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.get_2fa_secret");
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    Activate2FA({ commit }, activate_2fa_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.activate_2fa");
            this._vm.$axios
                .post(r, {
                    activate_2fa_data: activate_2fa_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        commit("set2FAActivated", 1);
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    Disable2FA({ commit }, verification_code) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.disable_2fa");
            this._vm.$axios
                .post(r, {
                    verification_code: verification_code
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        commit("set2FAActivated", 0);
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    Pre2FAGet2FASecret({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.pre2fa_get_2fa_secret");
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    Pre2FAActivate2FA({ commit }, activate_2fa_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.pre2fa_activate_2fa");
            this._vm.$axios
                .post(r, {
                    activate_2fa_data: activate_2fa_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        commit("set2FAActivated", 1);
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    ResendInviteEmail({ commit }, sub_accounts) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.send_invite_email");
            this._vm.$axios
                .post(r, {
                    sub_accounts: sub_accounts
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    ResendActivateEmail({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.resend_activate_email");
            this._vm.$axios
                .post(r, {
                    user_data: request_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    GetServerAccountsData({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.get_server_accounts_data");
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    GetApiKeys({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.get_api_keys");
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    GetUserSshKeys({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.get_user_ssh_keys");
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    AddUserSshKey({ commit }, ssh_key_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.add_user_ssh_key");
            this._vm.$axios
                .post(r, {
                    ssh_key_data: ssh_key_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    RemoveUserSshKeys({ commit }, ssh_keys_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route("user.remove_user_ssh_keys");
            this._vm.$axios
                .post(r, {
                    ssh_keys_data:ssh_keys_data
                })
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        resolve(response.data.data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },
};

const mutations = {
    storeUserData(state, user_data) {
        state.user_logged_in = true;
        state.user_data = Object.assign({}, {}, user_data);
        state.session_verified = true;
    },
    logoutUser(state) {
        state.user_logged_in = false;
        this._vm.$set(state, "user_data", {});
        this._vm.$set(state, "account_data", {});
        state.session_verified = true;
    },
    setSessionUserData(state, user_data) {
        state.user_data = Object.assign({}, {}, user_data);
        state.user_logged_in = true;
        state.session_verified = true;
    },
    setSessionAccountData(state, account_data) {
        state.account_data = Object.assign({}, {}, account_data);
    },
    setSessionAccountLimits(state, account_limits) {
        state.account_limits = Object.assign({}, {}, account_limits);
    },
    setCheckSessionExecuted(state) {
        state.check_session_executed = true;
    },
    set2FAActivated(state, two_fa_status) {
        if ("2fa_enabled" in state.account_data && "2fa_verified" in state.account_data) {
            this._vm.$set(state.account_data, "2fa_enabled", two_fa_status);
            this._vm.$set(state.account_data, "2fa_verified", two_fa_status);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
